import { render, staticRenderFns } from "./ExitImpersonate.vue?vue&type=template&id=077e9d25&"
import script from "./ExitImpersonate.vue?vue&type=script&lang=ts&"
export * from "./ExitImpersonate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports